module.exports = __webpack_public_path__ + "media/components/assets/email_icon-5e1c2bf545753e4cdc18c4eb55223f77.svg";